import { useCallback, useState } from "react";
import { useUserEntitlements } from "Utils/queries";
import {
  TRIAL_STAGES,
  dismissTrialBanner,
  getTrialBannerMessage,
  getTrialChip,
  getTrialDaysLeft,
  getTrialEndsAt,
  getTrialStage,
  isTrialBannerDismissed,
  markTrialEndsTodayModalShown,
  shouldShowTrialEndsTodayModal,
} from "Utils/trialStatus";

const resolveUserId = (user) => user?.id || user?.userId || user?.uuid || null;

const useTrialStatus = (user, { enabled = true } = {}) => {
  const userId = resolveUserId(user);
  const { data: entitlements } = useUserEntitlements(userId, {
    enabled: enabled && Boolean(userId),
  });
  // Bumped after a write to re-render and re-read storage.
  const [, setStorageVersion] = useState(0);

  const now = new Date();
  const trialEndsAt = getTrialEndsAt(entitlements);
  const stage = getTrialStage(trialEndsAt, now);
  const daysLeft = getTrialDaysLeft(trialEndsAt, now);

  const isDismissed = isTrialBannerDismissed(userId, stage, now);
  const showEndsTodayModal = shouldShowTrialEndsTodayModal(userId, stage, now);

  const dismissBanner = useCallback(() => {
    dismissTrialBanner(userId);
    setStorageVersion((version) => version + 1);
  }, [userId]);

  const markEndsTodayModalShown = useCallback(() => {
    markTrialEndsTodayModalShown(userId);
    setStorageVersion((version) => version + 1);
  }, [userId]);

  console.log("useTrialStatus", {
    stage,
    daysLeft,
    trialEndsAt,
    isTrial: stage !== TRIAL_STAGES.NONE,
    chip: getTrialChip(stage, daysLeft),
    bannerMessage: isDismissed ? null : getTrialBannerMessage(stage, daysLeft),
    dismissBanner,
    showEndsTodayModal,
    markEndsTodayModalShown,
  });

  return {
    stage,
    daysLeft,
    trialEndsAt,
    isTrial: stage !== TRIAL_STAGES.NONE,
    chip: getTrialChip(stage, daysLeft),
    bannerMessage: isDismissed ? null : getTrialBannerMessage(stage, daysLeft),
    dismissBanner,
    showEndsTodayModal,
    markEndsTodayModalShown,
  };
};

export default useTrialStatus;
